// src/hooks/useConfirm.ts
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@/store';
import { openConfirm, closeConfirm } from '@/store/slices/ui/UISlice';
import { selectConfirm } from '@/store/selectors/ui';
import type { UiConfirmState } from '@/types/ui.types';

/**
 * Generic confirm dialog controller backed by Redux UI slice.
 */
export function useConfirm() {
  const dispatch = useAppDispatch();
  const confirm = useSelector(selectConfirm);

  const open = useCallback((confirm: UiConfirmState) => {
    dispatch(openConfirm(confirm));
  }, [dispatch]);

  const close = useCallback(() => {
    dispatch(closeConfirm());
  }, [dispatch]);

  return { confirm, open, close };
}
